import React, { useEffect } from 'react';
import styles from './style/index.module.less';
import LoginForm from './form';

function Login() {
  useEffect(() => {
    document.body.setAttribute('arco-theme', 'dark');
  }, []);

  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <LoginForm />
    </div>
  );
}
Login.displayName = 'LoginPage';

export default Login;
